var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 14.7333H14.7333V6.84668L14.6333 6.73334C12.798 4.73252 10.7642 2.92324 8.56333 1.33334L8.46 1.26001H7.54L7.43666 1.33334C5.23576 2.92324 3.202 4.73252 1.36666 6.73334L1.26666 6.84668V14.7333H6.4V8.73334H9.6V14.7333ZM13.9333 13.9333H10.4V7.93334H5.6V13.9333H2.06666V7.15334C3.8067 5.27673 5.72456 3.5732 7.79333 2.06668H8.20666C10.2754 3.5732 12.1933 5.27673 13.9333 7.15334V13.9333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d9e15485f70ee0aaccf321e3138336af.svg";
export { ForwardRef as ReactComponent };